import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription, timer } from 'rxjs';
import { NetworkStatusService } from '../../services/network-status.service';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

@Component({
  selector: 'app-network-status',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="network-status-notification"
      [class.online]="isOnline"
      [class.offline]="!isOnline"
      [@slideInOut]="showNotification ? 'in' : 'out'"
    >
      <div class="notification-content">
        <div class="icon">
          <svg
            *ngIf="isOnline"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
            />
            <polyline points="9,11 12,14 22,4" />
          </svg>
          <svg
            *ngIf="!isOnline"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
            />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        </div>
        <span class="message">
          {{ isOnline ? 'Connection restored' : 'No internet connection' }}
        </span>
      </div>
    </div>
  `,
  styleUrls: ['./network-status.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          transform: 'translateY(0)',
          opacity: 1,
        })
      ),
      state(
        'out',
        style({
          transform: 'translateY(-100%)',
          opacity: 0,
        })
      ),
      transition('out => in', animate('300ms ease-in-out')),
      transition('in => out', animate('300ms ease-in-out')),
    ]),
  ],
})
export class NetworkStatusComponent implements OnInit, OnDestroy {
  isOnline = true;
  showNotification = false;
  private networkStatusSubscription?: Subscription;
  private hideNotificationSubscription?: Subscription;

  constructor(private networkStatusService: NetworkStatusService) {}

  ngOnInit(): void {
    this.isOnline = this.networkStatusService.isOnline();

    this.networkStatusSubscription = this.networkStatusService
      .getNetworkStatus()
      .subscribe((isOnline: boolean) => {
        // Only show notification if status actually changed
        if (this.isOnline !== isOnline) {
          this.isOnline = isOnline;
          this.showNotification = true;

          // Hide notification after 4 seconds
          this.hideNotificationSubscription?.unsubscribe();
          this.hideNotificationSubscription = timer(4000).subscribe(() => {
            this.showNotification = false;
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.networkStatusSubscription?.unsubscribe();
    this.hideNotificationSubscription?.unsubscribe();
  }
}
